import {
    AfterViewInit,
    Directive,
    ElementRef,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges,
} from "@angular/core"
import { Question } from "../../../models/student-assignment/question.model"
import { StudentAssignmentService } from "../../../services/student-assignment.service"

@Directive({
    selector: "[appMarkPage]",
})
export class MarkPageDirective implements AfterViewInit, OnChanges {
    @Input()
    public questions: Question[] = []

    constructor(
        public el: ElementRef,
        private renderer: Renderer2,
        private studentAssignmentService: StudentAssignmentService
    ) {}

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.questions.currentValue) {
            this.updateClasses()
        }
    }

    public ngAfterViewInit() {
        this.updateClasses()
        this.studentAssignmentService.updateMarks.subscribe((updateDetected) => {
            if (updateDetected) {
                setTimeout(() => {
                    this.updateClasses()
                }, 1)
            }
        })
    }

    private updateClasses() {
        this.questions.forEach((question, index) => {
            const button = this.el.nativeElement.querySelector(`.page-${index + 1}`)
            // tslint:disable-next-line:no-unused-expression
            button && this.renderer.removeClass(button, "submitted")
            if (question.hasAnswer() && button) {
                this.renderer.addClass(button, "submitted")
            }
        })
    }
}
